import { render, staticRenderFns } from "./TituloQuestao.vue?vue&type=template&id=59401265&scoped=true"
import script from "./TituloQuestao.vue?vue&type=script&lang=js"
export * from "./TituloQuestao.vue?vue&type=script&lang=js"
import style0 from "./TituloQuestao.vue?vue&type=style&index=0&id=59401265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59401265",
  null
  
)

export default component.exports